
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.926 10.945v-.5.5zm-9.828 0v.5-.5zm12.74-1.107l.38-.324-.38.324zM9.512 1.235l.381-.324-.38.324zm-.38.324l7.325 8.603.761-.648L9.893.91l-.761.648zm-7.589 8.603L8.87 1.559 8.11.911.782 9.514l.761.648zm2.555.283H1.674v1h2.424v-1zm1.171 5.885v-4.713h-1v4.713h1zm7.313.172h-7.14v1h7.14v-1zm.172-4.885v4.713h1v-4.713h-1zm3.572-1.172h-2.4v1h2.4v-1zm-2.572 1.172c0-.095.077-.172.172-.172v-1c-.647 0-1.172.525-1.172 1.172h1zm-1.172 5.885c.647 0 1.172-.525 1.172-1.172h-1a.172.172 0 01-.172.172v1zM4.27 16.33c0 .647.525 1.172 1.172 1.172v-1a.172.172 0 01-.171-.172h-1zm-.171-4.885c.095 0 .171.077.171.172h1c0-.647-.524-1.172-1.171-1.172v1zM.782 9.514c-.648.76-.108 1.931.892 1.931v-1a.172.172 0 01-.131-.283l-.761-.648zm15.675.648a.172.172 0 01-.13.283v1c.998 0 1.54-1.17.891-1.931l-.761.648zM9.893.912A1.172 1.172 0 008.109.91l.761.648a.172.172 0 01.262 0l.761-.648z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":"13","y":"19.002","width":"2","height":"8","rx":"1","transform":"rotate(90 13 19.002)","stroke":"#000C1F"}})])
          )
        }
      }
    